// extracted by mini-css-extract-plugin
export default {"container":"QW-z","title":"RW-z","link":"SW-z"};